<script>
    export default {
        name: "StepSeven",
        props: {
            'course': Object,
            'offer': Object,
            'companyprop': Object,
            'legalformsprop': Array,
            'lesson': {}
        },
        data() {
            return {
                company: this.companyprop,
                loading: false,
                legalForms: {},
                isDisabledButton: false,
            }
        },
        mounted() {
            this.legalForms = this.legalformsprop;
        },
        methods: {
            isLoading() {
                return this.loading;
            },
            previousStep() {
                this.$emit('update-step', 6);
            },
            postForm() {
                var self = this;
                this.loading = true;
                this.$bus.$emit('searching');

                if (this.company.legal_form_id) {
                    this.offer.company_legal_form_id = this.company.legal_form_id
                }
                if (this.company.typology_id) {
                    this.offer.company_typology_id = this.company.typology_id
                }

                axios({
                    method: 'put',
                    url: '/courses/' + this.course.courseId + '/offer',
                    data: {
                        offer: this.offer,
                    },
                }).then((response) => {
                    this.loading = false;
                    this.$bus.$emit('filtered');

                    if ((this.company.accept_payments === 0 || this.company.accept_payments === null) && (this.lesson.price > 0) && !this.offer.hasLessons && !this.offer.hasSubscription) {
                        this.$bus.$emit('ask_for_contracts');

                    } else {

                        if (this.offer.hasLessons) {
                            this.$emit('update-step', 8, 7);
                            return;
                        }

                        if (this.offer.hasSubscription) {
                            this.$emit('update-step', 9, 7);
                            return;
                        }

                        window.location = '/societa_sportive/' + this.company.slug + '/dashboard/corsi'
                    }

                }).catch((error) => {
                    this.loading = false;
                    this.$bus.$emit('filtered');
                    this.message = 'Error';
                });
            }
        },
        watch: {
            // 'offer.quote': {
            //     handler: function (newValue) {
            //         if (this.company.typology_id == 2 || this.company.typology_id === true) {
            //             if (!newValue) {
            //                 this.isDisabledButton = true;
            //             } else {
            //                 this.isDisabledButton = false;
            //             }
            //         } else {
            //             this.isDisabledButton = false;
            //         }
            //     },
            // },
            // 'company.typology_id': {
            //     handler: function (newValue) {
            //         if (newValue === true) {
            //             if (this.offer.quote) {
            //                 this.isDisabledButton = false;
            //             } else {
            //                 this.isDisabledButton = true;
            //             }
            //         } else {
            //             this.isDisabledButton = false;
            //         }
            //     },
            // },
        },
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/course/StepSeven.vue